import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import BlacklistReportForm from "@/components/BlacklistReportForm";
import { useLang } from "../context/LanguageContext";
import { blT } from "../content/blacklistI18n";

const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("saubereko_applicant_token")}` } });

export default function CiernaListina() {
  const { lang } = useLang();
  const T = blT(lang);
  const logged = !!localStorage.getItem("saubereko_applicant_token");
  return (
    <div className="min-h-screen bg-black text-white pt-32 pb-24 px-6" data-testid="blacklist-page">
      <div className="max-w-4xl mx-auto">
        <p className="text-red-300 text-xs tracking-[0.25em] uppercase mb-3 flex items-center gap-2"><ShieldAlert size={14} /> {T.over}</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl" data-testid="blacklist-title">{T.title}</h1>
        <p className="text-white/55 mt-4 max-w-2xl" data-testid="blacklist-intro">{T.intro}</p>
        {!logged ? (
          <div className="mt-10 border border-white/10 p-6" data-testid="blacklist-login-required">
            <p className="text-white/70">{T.loginReq}</p>
            <Link to="/ziadost" className="inline-block mt-4 bg-[#D4AF37] text-black font-semibold px-6 py-3 text-sm" data-testid="blacklist-login-link">{T.login}</Link>
          </div>
        ) : <BlacklistReportForm auth={auth} T={T} />}
        {!logged && <p className="text-amber-200/70 text-xs mt-12 border-l-2 border-amber-300/50 pl-3" data-testid="blacklist-disclaimer">{T.disclaimer}</p>}
        <p className="text-white/30 text-xs mt-8" data-testid="blacklist-footer-note">{T.footer}</p>
      </div>
    </div>
  );
}
